module.exports = __webpack_public_path__ + "img/catalogo.4cd79aac.webp";